<ng-container *ngIf="badge?.anchorLink else noAnchor">
  <div class="mrt-badge {{badge?.badgeColor}} {{badge?.anchorLink ? 'cursor-pointer' : ''}}"
    (click)="onAnchorClick(badge?.anchorLink)" enTooltip title="{{ badge?.tooltip }}">
    <ng-container *ngTemplateOutlet="badgeTemplate"></ng-container>
  </div>
</ng-container>

<ng-template #noAnchor>
  <div class="mrt-badge {{badge?.badgeColor}}" enTooltip title="{{ badge?.tooltip }}">
    <ng-container *ngTemplateOutlet="badgeTemplate"></ng-container>
  </div>
</ng-template>

<ng-template #badgeTemplate>
  <div class="d-flex align-items-center">
    <ng-container *ngIf="badge.locked">
      <div class='freemium-lock mr-3'>
        <i class='fa fa-lock'></i>
      </div>
    </ng-container>
    <ng-container *ngIf="!badge.locked">
      <ng-container *ngIf="badge?.icon">
        <img width="32" [attr.src]="badge?.icon" alt="Badge Icon" />
      </ng-container>
      <ng-container *ngIf="!badge?.icon">
        <ng-container [ngSwitch]="badge?.detected">
          <ng-container *ngSwitchCase="'N/A'">
            <img width="32" src="/assets/images/unknown.svg" alt="Insufficient Data Icon" />
          </ng-container>
          <ng-container *ngSwitchDefault>
            <img width="32"
              src="/assets/images/icon-indicator-{{badge?.reverse? !badge?.detected : badge?.detected}}.svg"
              alt="Badge Icon" />
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>

    <div class="label">
      <div class="text">{{badge?.text}}</div>
      <ng-container *ngIf="!badge.locked">
        <ng-container *ngIf="!badge?.detectedText">
          <div class="detect {{badge?.reverse? !badge?.detected : badge?.detected}}">
            <ng-container *ngIf="badge?.detected !== 'N/A'">
              {{ badge?.detected ? 'Detected' : 'Not Detected' }}
            </ng-container>
            <ng-container *ngIf="badge?.detected === 'N/A'">Unknown</ng-container>
          </div>
        </ng-container>
        <ng-container *ngIf="badge?.detectedText">
          <div class="detect" [innerHTML]="badge?.detectedText"></div>
        </ng-container>
      </ng-container>
    </div>
    <ng-container *ngIf="badge?.rightIcon">
      <img [attr.src]="badge?.rightIcon" class="right-icon" alt="Badge Right Icon" />
    </ng-container>
  </div>
</ng-template>